export function isDaylightSavingTime(date = new Date()) {
  // Obtenez le décalage horaire actuel en minutes
  const offset = date.getTimezoneOffset()

  // Créez une date en janvier (pas d'heure d'été en janvier)
  const january = new Date(date.getFullYear(), 0, 1)
  const januaryOffset = january.getTimezoneOffset()

  // Créez une date en juillet (heure d'été possible en juillet)
  const july = new Date(date.getFullYear(), 6, 1)
  const julyOffset = july.getTimezoneOffset()

  // Si le décalage actuel est différent de celui de janvier
  // alors on est probablement en heure d'été
  return offset < januaryOffset || offset < julyOffset
}
